var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.461,
    height: 30.111,
    viewBox: "0 0 17.461 30.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_10b8fcaa-8d15-4525-95f4-5d8a10de6700",
    "data-name": "10b8fcaa-8d15-4525-95f4-5d8a10de6700",
    d: "M22.461,2H18.245a7.029,7.029,0,0,0-7.028,7.028v4.217H7v5.622h4.217V30.111h5.622V18.867h4.217l1.406-5.622H16.839V9.028a1.406,1.406,0,0,1,1.406-1.406h4.217Z",
    transform: "translate(-7 -2)",
    fill: "none",
    stroke: "#fcfcfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIcon1);
export default __webpack_public_path__ + "static/media/WhiteIcon-1.ac3bb9db6659b9cc78a9cc53d74d0227.svg";
export { ForwardRef as ReactComponent };